import { NextPage } from 'next'
import { FC, useEffect } from 'react'
import { useParams } from 'next/navigation'
import { useSelector } from 'react-redux'

import Router, { routes } from '../routes/Router'
import { useServiceRequest } from '../hooks/useServiceRequest'
import { actions, selectors } from '../redux'

const ClassifiedUpdateGuard = (Page: NextPage<any>): FC<any> => {
  return function ClassifiedUpdateGuard(props) {
    const params = useParams<{ id?: string }>()
    const user = useSelector(selectors.auth.user)

    const [{ data: classified, pending, success, complete }, getClassified] =
      useServiceRequest(
        selectors.classifieds.getClassifiedById,
        actions.classifieds.getClassifiedByIdRequest,
        actions.classifieds.getClassifiedByIdReset
      )

    useEffect(() => {
      const id = params?.id

      if (id && user) {
        getClassified({ id: id, filters: { user: { id: { $eq: user.id } } } })
      }
    }, [getClassified, params, user])

    useEffect(() => {
      if (
        (complete && !success) ||
        (complete &&
          success &&
          String(classified?.user?.id ?? '') !== String(user?.id ?? ''))
      ) {
        Router.pushRoute(routes.classifieds)
      }
    }, [complete, success, classified, user])

    if (pending || !classified) {
      return null
    }

    return <Page {...props} classified={classified} />
  }
}

export default ClassifiedUpdateGuard
